import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="session-activity"
export default class extends Controller {
  static values = {
    refreshUrl: String,
    minInterval: Number,
    debounce: Number
  }

  connect() {
    this.lastActivitySentAt = Date.now()
    console.log("[SessionActivity] Controller connected. Min interval:", this.minIntervalValue, "ms, Debounce:", this.debounceValue, "ms")
    this.setupListeners()
  }

  disconnect() {
    const events = ["click", "mousemove", "keydown", "scroll", "touchstart"]
    events.forEach(evt => {
      document.removeEventListener(evt, this.registerActivity.bind(this))
    })
  }

  setupListeners() {
    const events = ["click", "mousemove", "keydown", "scroll", "touchstart"]
    events.forEach(evt => {
      document.addEventListener(evt, this.registerActivity.bind(this))
    })
  }

  registerActivity() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.sendActivity(), this.debounceValue)
  }

  sendActivity() {
    const now = Date.now()
    const timeSinceLastSend = now - this.lastActivitySentAt

    if (timeSinceLastSend < this.minIntervalValue) {
      console.log("[SessionActivity] Skipping refresh. Time since last send:", timeSinceLastSend, "ms (min interval:", this.minIntervalValue, "ms)")
      return
    }

    this.lastActivitySentAt = now
    console.log("[SessionActivity] Sending activity refresh...")

    fetch(this.refreshUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
    })
    .then(response => {
      if (response.ok) {
        console.log("[SessionActivity] Session refresh successful")
      } else if (response.status === 401) {
        console.warn("[SessionActivity] Session expired (401 Unauthorized)")
      } else {
        console.warn("[SessionActivity] Refresh failed with status:", response.status)
      }
    })
    .catch(error => {
      console.error("[SessionActivity] Error refreshing session:", error)
    })
  }
}

